import applicationsMockup from '@/images/survey/onboarding/applications-mockup.svg';
import discoveryMockup from '@/images/survey/onboarding/discovery-mockup.svg';
import emailDripMockup from '@/images/survey/onboarding/email-drips-mockup.svg';

export const TRIAL_USER_ONBOARDING_MODAL_DATA = [
  {
    step: 1,
    header: 'Welcome to SARAL - Your Influencer OS!',
    description:
      'Congrats on getting the trial. We’re here to make you win with influencers. Watch this short welcome video for an overview of the platform and what to do next.',
    image: 'https://saral-onboarding-thumbnails-dev.s3.ap-south-1.amazonaws.com/trial/Intro+Modal.png',
    isVideo: true,
    videoUrl:
      'https://saral-onboarding-thumbnails-dev.s3.ap-south-1.amazonaws.com/trial/New+Onboarding+-+Founder+Welcome+Video.mp4',
  },
  {
    step: 2,
    header: 'Discover untapped influencers for your brand',
    description:
      'Find influencers who talk about certain topics, reverse search by a brand,  or find people similar to your high-perfoming influencers.',
    image: discoveryMockup,
  },
  {
    step: 3,
    header: 'Automate Personalized Reachouts',
    description:
      'Build lists, send them personalized email campaigns, and manage relationships. Use Email Drips on the right and then manage everyone under Relationships.',
    image: emailDripMockup,
  },
  {
    step: 4,
    header: 'Turn Followers & Customers into Ambassadors',
    description:
      'Working with influencers who already know your brand is a great way to get some quick wins. Brands typically get dozens of applications passively each week!',
    image: applicationsMockup,
  },
];
